<template>
  <b-row>
    <b-col class="col-md-12 col-12">
      <div>
        <div class="tt-alert-block">
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="success"
              size="lg"
              show
              v-if="savingStatus === 'successSave'"
              >New place saved successfully.</b-alert
            >
          </transition>
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="danger"
              size="lg"
              show=""
              v-if="savingStatus === 'failedSave'"
              >There was a problem saving the place. Please try again</b-alert
            >
          </transition>
        </div>
      </div>
      <h2 class="text-center font-weight-bold mb-0">Locations</h2>
      <h6 class="text-center mt-4">
        {{ isEditing ? "Editing saved place" : "Manage places" }}
      </h6>
      <validation-observer v-slot="{ invalid, validate, reset }" ref="observer">
        <b-form @submit.prevent="savePlace" class="tt-mt">
          <div class="row">
            <b-form-group id="input-group-2" class="col-md-12" label="Name">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-input
                  id="input-2"
                  required
                  placeholder="e.g. Mugg and Bean Durbanville"
                  v-model="place.name"
                  @input="reset"
                  aria-required="true"
                ></b-form-input>
                <span class="text-danger text-left">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
            <b-form-group id="input-group-3" class="col-md-12" label="Address">
              <validation-provider :rules="'required'" v-slot="{ errors }">
                <b-form-input
                  id="input-3"
                  required
                  placeholder="e.g: 12 Church street, Wellington"
                  v-model="place.extra"
                  aria-required="true"
                ></b-form-input>
                <span class="text-danger text-left">{{ errors[0] }}</span>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group id="input-group-3" class="col-md-12">
              <button
                type="submit"
                class="align-content-start mt-3 btn text-white pr-5 pl-5 w-100 tt-border-radius"
                :class="{ 'btn-success': !isEditing, 'btn-warning': isEditing }"
                @click="validate"
              >
                {{ isEditing ? "Update place" : "Save Place" }}
              </button>
            </b-form-group>
          </div>
        </b-form>
      </validation-observer>
    </b-col>
    <b-col class="col-md-12 col-12">
      <hr class="mt-3" />
      <div class="mt-3">
        <place :limit="true"></place>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Place from "@/views/Place";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { excluded, required } from "vee-validate/dist/rules";
import { DateTime as TimeFormatter } from "luxon";
import { mapState } from "vuex";
import sha1 from "js-sha1";

extend("required", {
  ...required,
  message: "This field is required"
});

extend("excluded", {
  ...excluded,
  message: "This name already exists"
});

export default {
  name: "NewPlace",
  components: {
    Place,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      newPlace: {
        _id: new Date().toISOString(),
        type: "place",
        is_synced: false,
        is_default: false,
        is_deleted: false,
        hash: "",
        status: 0,
        extra: "",
        name: "",
        saved_at: new Date().toISOString()
      },
      showDismissibleAlert: true,
      multipleVehicles: false
    };
  },
  props: {
    defaultVehicle: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$store.dispatch("place/getPlacesAction");
    this.$store.dispatch("place/getLastTenAction");
  },
  created() {
    this.newPlace.hash = sha1(new Date().toISOString() + Math.random());
  },
  computed: {
    ...mapState({
      savedPlaces: state => state.place.all,
      success: state => state.place.actionSuccessMsg,
      error: state => state.place.actionErrorMsg
    }),

    savedPlacesStr() {
      var savedPlaces = "";
      for (let place of this.savedPlaces) {
        savedPlaces += place.name + ", ";
      }
      return savedPlaces;
    },
    savingStatus() {
      return this.error || this.success;
    },

    place: function() {
      if ("editablePlace" in this.$route.params) {
        this.updateTimeStampOnEdit(this.$route.params.editablePlace);
        window.scrollTo(0, 0);
        return this.$route.params.editablePlace;
      } else {
        return this.newPlace;
      }
    },
    isEditing: function() {
      return "editablePlace" in this.$route.params;
    }
  },

  methods: {
    savePlace: function() {
      this.place.saved_at = TimeFormatter.fromISO(this.place.saved_at).toFormat(
        "y-MM-dd H:m:s"
      ); //Todo : could be done in a better way
      this.$store.commit("place/save", this.place);
      this.resetForm();
      this.$refs.observer.reset();
      this.$store.dispatch("place/getPlacesAction");
      this.$root.$emit("newRecordSaved");
      if (this.$route.name !== "new-place") {
        this.$router.push({ name: "new-place" });
      }
    },
    resetForm: function() {
      this.place._id = new Date().toISOString();
      this.place.name = "";
      this.place.extra = "";
      this.place.saved_at = new Date().toISOString();
      this.newPlace.hash = sha1(new Date().toISOString() + Math.random());
    },

    updateTimeStampOnEdit: function(place) {
      place.saved_at = new Date().toISOString();
    }
  },
  watch: {
    // make sure the edited location is saved as not synced yet
    place: function(value) {
      value.is_synced = false;
      value.save_at = new Date().toISOString();
    },
    savingStatus: function() {
      this.$store.commit("place/clearMes");
    }
  }
};
</script>

<style scoped></style>
